import React, { useState } from 'react'
import AresNavBar from '../Layout/NavBar/NavBar';
import SideBar from '../Layout/SideBar/SideBar';
import { ModalManager } from 'react-dynamic-modal';
import ConfigCreditCardModal from './Config';
import CreditCardCarousel from './CreditCardCarousel';

import 'react-data-table-component-extensions/dist/index.css';
import 'react-multi-carousel/lib/styles.css';
import './index.css'
import { AiOutlineCreditCard, AiOutlinePlusCircle } from 'react-icons/ai';
import FinancialTabs from './FinancialTabs';

const dataBilling = [
  { id: 1, data: '2020-09-07', modo: 'com final 5151', transacao: 'cobrança', metodo: 'cartão de credito', valor: '590,95 USD', pending: false },
  { id: 2, data: '2020-12-07', modo: 'com final 5123', transacao: 'cobrança', metodo: 'cartão de credito', valor: '590,95 USD', pending: false },
  { id: 3, data: '2020-09-11', modo: 'com final 6611', transacao: 'cobrança', metodo: 'cartão de credito', valor: '590,95 USD', pending: false },
  { id: 4, data: '2020-12-12', modo: 'com final 9126', transacao: 'cobrança', metodo: 'cartão de credito', valor: '590,95 USD', pending: false },
  { id: 5, data: '2020-02-07', modo: 'com final 7777', transacao: 'cobrança', metodo: 'cartão de credito', valor: '590,95 USD', pending: true },
  { id: 6, data: '2020-09-07', modo: 'com final 8252', transacao: 'cobrança', metodo: 'cartão de cre6ito', valor: '590,95 USD', pending: false },
  { id: 7, data: '2020-09-07', modo: 'com final 1123', transacao: 'cobrança', metodo: 'cartão de credito', valor: '590,95 USD', pending: false },
  { id: 8, data: '2020-09-07', modo: 'com final 6133', transacao: 'cobrança', metodo: 'cartão de credito', valor: '590,95 USD', pending: true },
  { id: 9, data: '2020-09-07', modo: 'com final 9911', transacao: 'cobrança', metodo: 'cartão de credito', valor: '590,95 USD', pending: false },
  { id: 10, data: '2020-09-07', modo: 'com final 9511', transacao: 'cobrança', metodo: 'cartão de credito', valor: '590,95 USD', pending: false },
]

const dataBank = [
  { id: 1, name: 'Lara Lara', agencia: '2688', bank_name: 'Bradesco', conta: '1638186-1', type: '1' },
  { id: 2, name: 'Lara Lara', agencia: '6517', bank_name: 'Bradesco', conta: '1638186-1', type: '1' },
  { id: 3, name: 'Matheus Lara', agencia: '2688', bank_name: 'Bradesco', conta: '31635-2', type: '3' },
  { id: 4, name: 'Klaus Klaus', agencia: '2688', bank_name: 'Santander', conta: '37320701-8', type: '2' },
  { id: 5, name: 'Lara Lara', agencia: '2688', bank_name: 'Bradesco', conta: '31635-2', type: '1' },
  { id: 6, name: 'Lara Lara', agencia: '2688', bank_name: 'Bradesco', conta: '48195163-2', type: '13' },
  { id: 7, name: 'Maicon Douglas', agencia: '2688', bank_name: 'Santander', conta: '0636298-2', type: '3' },
]

const creditCardsData = [
  {
    expiry: '12/12',
    cvc: '411',
    name: 'Jorge jorge',
    number: '4857 2526 4951',
    main: true
  },
  {
    expiry: '12/12',
    cvc: '714',
    name: 'klaus klaus',
    number: '5594 1672 4092 0478',
    main: false
  },
  {
    expiry: '12/12',
    cvc: '991',
    name: 'Ana jorge',
    number: '5066 9911 1111 1118',
    main: false
  },
  {
    expiry: '12/12',
    cvc: '514',
    name: 'Lara lara',
    number: '3019 739288 3714',
    main: false
  },
  {
    expiry: '12/12',
    cvc: '412',
    name: 'Rebeca lara',
    number: '6062 8202 8978 1026',
    main: false
  },
  {
    expiry: '12/12',
    cvc: '114',
    name: 'Mateus lara',
    number: '3751 296126 36211',
    main: false
  },
]

function openCreditCardModal(creditCard) {
  ModalManager.open(<ConfigCreditCardModal creditCard={creditCard} />)
}

export default function Financial() {
  const [creditCards, setCreditCards] = useState(creditCardsData)
  const [billingList, setBillingList] = useState(dataBilling)
  const [bankListList, setbankListList] = useState(dataBank)

  return (
    <div>
      <AresNavBar />
      <SideBar />
      <div className="Financial">
        <div className="container-header">
          <h1>Financeiro</h1>
          <div className="center">
            <span className="title-container">
              Cartões de Crédito
              <AiOutlineCreditCard />
            </span>
          </div>
        </div>
        <div className={creditCards.length !== 1 ? "content-container" : "content-container-one-card"}>
          <span className="add-card-button" onClick={() => openCreditCardModal(
            {
              expiry: '',
              cvc: '',
              name: '',
              number: '',
              main: false
            }
          )}>
            <AiOutlinePlusCircle size="2em" />
          </span>
          <CreditCardCarousel
            creditCard={creditCards}
            openCreditCardModal={openCreditCardModal} />
        </div>
        <hr id="billings" />
        <FinancialTabs billings={billingList} BankAccounts={bankListList} />
      </div>
    </div>
  )
}
